import React from "react";
import "./CircularProgressBar.css";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

export default function CircularProgressBar({ percentage }) {
  return (
    <div className="circularProgressContainer">
      <CircularProgressbar
        value={percentage}
        text={percentage === 0 ? "0" : percentage}
        styles={buildStyles({
          textColor: "#FFF",
          pathColor: "#4caf50",
          trailColor: "transparent",
          textSize: "1.2rem",
          strokeWidth: 5,
        })}
      />
    </div>
  );
}
